import { Component, OnInit, Renderer2 } from '@angular/core';
import { SocketService } from './services/socket.service';
import { Router } from '@angular/router';
import { AuthService } from './core/authservice/auth.service';
import { AuthUtils } from './core/authservice/auth.utils';
import { NavigationService } from './services/navigation.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from './core/services/language.service';
import { Store } from '@ngrx/store';
import { loadMenu } from './dashboard/layouts/menu/menu.actions';
import { SplashScreenService } from './splash-screen.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})


export class AppComponent implements OnInit {
  title = 'منصة أنا طالب | التعليم مدعوم بالذكاء الاصطناعي - ANATALEB | Education with AI-Powered';
  isDisconnected = false;

  constructor(
    private socketService: SocketService,
    private authService: AuthService,
    private router: Router,
    private navigationService: NavigationService,
    private titleService: Title,
    public translate: TranslateService,
    private store: Store,
    public languageService: LanguageService,
    private _splashScreenService: SplashScreenService
  ) {}

  ngOnInit(): void {
      // Check if we have a user in localStorage
      const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
      if (user && user.role) {
        // Dispatch loadMenu with that role
        this.store.dispatch(loadMenu({ role: user.role }));
      }    

    this.initializeLanguage();
    const currentPath = window.location.pathname; // e.g. '/home/checkin'
  
    // Only sign out if token is expired and we're not in a /home route.
    if (!currentPath.includes('/home') && AuthUtils.isTokenExpired(this.authService.accessToken)) {
      this.authService.signOut();
    }

    
//check if current user is not verified (email)
// if (this.authService.currentUserValue && !this.authService.currentUserValue.emailVerified) {
//   this.router.navigate(['/auth/twostep']);
// }
//this.checkConnection();

  }
  initializeLanguage(): void {
    const lang = localStorage.getItem('lang') || 'ar';
    this.setLanguage(lang);
  }
  setLanguage(lang: string): void {
    this.translate.use(lang);
    this.setTranslatedTitle();
    this.setLanguageStyle();
  }

  setTranslatedTitle() {
    this.translate.get('general.pageTitle').subscribe((translatedTitle: string) => {
      this.titleService.setTitle(translatedTitle);
    });
  }




  setLanguageStyle(): void {
    const storageKey = 'lang';
    const defaultLang = 'ar'; // Fallback language
    const lang = localStorage.getItem(storageKey) || defaultLang;
    if (lang === 'ar') {
        document.documentElement.classList.add('rtl');
        document.documentElement.setAttribute('dir', 'rtl');
        
        this.languageService.setLanguage(lang);
        this.toggleRtl(true);

      } else {
        document.documentElement.classList.remove('rtl');
        document.documentElement.setAttribute('dir', 'ltr');
        this.toggleRtl(false);
      }
    }
    


    toggleRtl(isRtl: boolean): void {
      const head = document.getElementsByTagName('head')[0];
      let rtlStyleLink = document.getElementById('rtl-style') as HTMLLinkElement;
    
      if (isRtl) {
        if (!rtlStyleLink) {
          rtlStyleLink = document.createElement('link');
          rtlStyleLink.id = 'rtl-style';
          rtlStyleLink.rel = 'stylesheet';
          rtlStyleLink.href = 'styles.rtl.css'; // Link to the compiled CSS file
          head.appendChild(rtlStyleLink);
        }
      } else {
        if (rtlStyleLink) {
          head.removeChild(rtlStyleLink);
        }
      }
    }
    
    
  /**
   * Check if the user is disconnected
   */
  checkConnection(): void {
    this.socketService.connectionStatus.subscribe(isConnected => {
      const currentUrl = this.router.url;
      if (!isConnected) {
          this.isDisconnected = true;
          this.navigationService.setCurrentUrl(currentUrl);
          console.log('Navigating to error page...');
          this.router.navigate(['/error/page-500']);
      } else {
  
if (this.isDisconnected) {
  const storedUrl = this.navigationService.getCurrentUrl();
  console.log('Reconnecting to the stored URL:', storedUrl);
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate([storedUrl]);
      });
    }
 }
    });
  }
}